import React from 'react';
import { clsx } from 'clsx';

import styles from './WaypointCircle.module.scss';

type WaypointCircleType =
  | 'start'
  | 'end'
  | 'rabbit'
  | 'temporary'
  | 'number'
  | 'icon'
  | null;

interface WaypointCircleProps {
  /**
   * Waypoint type - controls how the waypoint looks and it's size
   */
  type?: WaypointCircleType;

  theme?: 'light' | 'dark';

  /**
   * Enlarges hit area of the waypoint to make it easier to click or interact with when a
   * waypoint is added on the map
   */
  enlargeHitArea?: boolean;

  className?: string;
  children?: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  onMouseEnter?: React.MouseEventHandler<HTMLDivElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLDivElement>;
  onContextMenu?: React.MouseEventHandler<HTMLDivElement>;
}

export const WaypointCircle = ({
  type,
  theme = 'light',
  enlargeHitArea = false,
  children,
  className,
  onClick,
  onMouseEnter,
  onMouseLeave,
  onContextMenu
}: WaypointCircleProps) => {
  return (
    <div
      className={clsx(
        styles.waypoint,
        type && styles[type],
        styles[theme],
        enlargeHitArea && styles.enlargeHitArea,
        className
      )}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onContextMenu={onContextMenu}
    >
      <div className={styles.circle}>{children}</div>
    </div>
  );
};
